module.exports = __webpack_public_path__ + "img/W7041-full.abf0c2f5.jpg";